<template>
  <el-dialog id="popup_dialog" :title="titlu" :visible.sync="showPopup" class="custom-width" append-to-body>
    <div>
      <el-form label-position="top" :inline="false" :rules="rules" label-width="100%" :model="selectedObject"
        ref="my-form" @submit.prevent="save" v-loading="loadingVisible">
        <el-row :gutter="15">
          <el-col :md="8">
            <el-form-item  label="Nume" prop="Nume">
              <el-input class="full-width" v-model="selectedObject.Nume" />
            </el-form-item>
          </el-col>
          <el-col :md="8">
            <el-form-item label="Marca" prop="IdMarca">
              <el-select class="full-width" filterable v-model="selectedObject.IdMarca" placeholder="Select marca">
                <el-option v-for="item in MarciMasini" :key="item.Id" :label="item.Nume" :value="item.Id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="8">
            <el-form-item label="Tip">
              <el-select class="full-width" v-model="selectedObject.Tip" placeholder="Selectează" clearable>
                <el-option label="Normal" value="Normal"></el-option>
                <el-option label="SUV" value="SUV"></el-option>
                <el-option label="Autoutilitar" value="Autoutilitar"></el-option>
                <el-option label="Supercar" value="Supercar"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showPopup = false"> Renunta </el-button>
        <el-button type="primary" @click="save"> Salveaza </el-button>
      </span>
    </div>
  </el-dialog>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";

export default {
  name: "Tipuri_masini_dialog",
  extends: BasePage,
  data() {
    return {
      baseUrl: "",
      showPopup: false,
      titlu: "",
      mode: "add",
      selectedObject: {
        Nume: "",
      },
      MarciMasini: [],
      Info: {},
      rules: {
        Nume: [{ required: true, message: "Campul este obligatoriu" }],
        IdMarca: [{ required: true, message: "Campul este obligatoriu" }],
      },
    };
  },
  methods: {
    show_me: async function (id) {
      this.showPopup = true;
      if (id == null) {
        this.mode = "add";
        this.titlu = "Adauga un tip de masina";
        this.selectedObject = {};
      } else {
        this.mode = "edit";
        this.titlu = "Editeaza un tip de masina";
        var result = await this.post("tipuri_masini/get_info_item_dialog", {
          id: id,
        });
        this.selectedObject = result.Item;
      }
    },

    show_me_cu_marca: async function (id_marca) {
      this.showPopup = true;

      this.mode = "add";
      this.titlu = "Adauga un tip de masina";


      this.selectedObject.IdMarca = id_marca;

    },
    async get_info() {
      var response = await this.post("tipuri_masini/get_info_for_dialog");
      this.MarciMasini = response.MarciMasini;
      // console.log(this.MarciMasini);
    },
    save: async function () {
      await this.$refs["my-form"].validate(async (valid) => {
        if (valid) {
          await this.post("tipuri_masini/save", {
            mode: this.mode,
            object: this.selectedObject,
          });
          this.showPopup = false;
          this.selectedObject = {};
          this.$emit("save");
        }
      });
    },
  },
  mounted: function () {
    this.baseUrl = settings.BASE_URL;
    this.get_info();
  },
};
</script>

<style lang="less">
.full-width {
  width: 100% !important;
}
#popup_dialog {
  .full-width {
    width: 100% !important;
  }

  .container {
    width: 100% !important;
  }

  @media only screen and (max-width: 600px) {
    .el-dialog {
      min-width: 90vw !important;
    }
  }
}
</style>